// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__17L1h","col":"styles_col__VFjbS"};